/*
 * Copyright (c) 2026 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { LoggedInUser } from '@irian-ro/auth-shared-module';
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

export  class LoggedInContext {
  loggedInUser: LoggedInUser | undefined = undefined;
  legalEntityUuid: string | undefined = undefined;
  publicBusinessProfileUuid: string | undefined = undefined;
  companyName: string | undefined = undefined;
  companyCountry: string | undefined = undefined;
  serviceProvider: boolean | undefined = undefined;
  companyType: CompanyType | undefined = undefined;
  paymentTermOverdue: boolean | undefined = undefined;
  accountStatusUuid: string | undefined = undefined;
  employeeUuid: string | undefined = undefined;
  companyDetailsValidated: boolean | undefined = undefined;

  constructor() {
    this.loggedInUser = new LoggedInUser();
  }
}
